var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 38,
    viewBox: "0 0 98 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.546 28.865C57.751 28.865 59.551 30.65 59.551 32.87C59.551 35.09 57.766 36.875 55.546 36.875C53.326 36.875 51.541 35.09 51.541 32.87C51.541 30.65 53.326 28.865 55.546 28.865ZM55.546 27.74C52.711 27.74 50.416 30.035 50.416 32.87C50.416 35.705 52.711 38 55.546 38C58.381 38 60.676 35.705 60.676 32.87C60.676 30.035 58.381 27.74 55.546 27.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4698 28.865C18.6748 28.865 20.4748 30.65 20.4748 32.87C20.4748 35.09 18.6898 36.875 16.4698 36.875C14.2498 36.875 12.4648 35.09 12.4648 32.87C12.4648 30.65 14.2498 28.865 16.4698 28.865ZM16.4698 27.74C13.6348 27.74 11.3398 30.035 11.3398 32.87C11.3398 35.705 13.6348 38 16.4698 38C19.3048 38 21.5998 35.705 21.5998 32.87C21.5998 30.035 19.3048 27.74 16.4698 27.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.541 21.785H81.541V22.865H84.541V21.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5405 14.285H6.06055V15.365H69.5405V14.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5405 5.28503H9.06055V6.36503H75.5405V5.28503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5405 9.78503H7.56055V10.865H72.5405V9.78503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5405 18.785H4.56055V19.865H66.5405V18.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.531 32.285C61.801 29.765 63.946 27.785 66.541 27.785C69.136 27.785 71.281 29.765 71.551 32.285H78.001V1.86503H0.541016V0.785034H78.541C78.841 0.785034 79.081 1.02503 79.081 1.32503V8.28503H90.481C90.676 8.28503 90.856 8.39003 90.946 8.55503L97.006 19.04C97.051 19.115 97.081 19.22 97.081 19.31V29.81C97.081 31.76 95.491 33.35 93.541 33.35H92.551C92.281 35.87 90.136 37.85 87.541 37.85C84.946 37.85 82.801 35.87 82.531 33.35H71.551C71.281 35.87 69.136 37.85 66.541 37.85C63.946 37.85 61.801 35.87 61.531 33.35H59.506C59.521 33.185 59.551 33.02 59.551 32.855C59.551 32.66 59.521 32.465 59.491 32.27H61.531V32.285ZM90.166 9.36503H83.581V18.785H95.611L90.166 9.36503ZM87.541 36.785C89.731 36.785 91.501 35.015 91.501 32.825C91.501 30.635 89.731 28.865 87.541 28.865C85.351 28.865 83.581 30.635 83.581 32.825C83.581 35.015 85.351 36.785 87.541 36.785ZM79.081 32.285H82.531C82.801 29.765 84.946 27.785 87.541 27.785C90.136 27.785 92.281 29.765 92.551 32.285H93.541C94.891 32.285 96.001 31.175 96.001 29.825V19.865H79.081V32.285ZM79.081 18.785H82.501V9.36503H79.081V18.785ZM66.541 36.785C68.731 36.785 70.501 35.015 70.501 32.825C70.501 30.635 68.731 28.865 66.541 28.865C64.351 28.865 62.581 30.635 62.581 32.825C62.581 35.015 64.351 36.785 66.541 36.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.431 33.365C20.446 33.2 20.476 33.035 20.476 32.87C20.476 32.675 20.446 32.48 20.416 32.285H51.601C51.571 32.48 51.541 32.675 51.541 32.87C51.541 33.035 51.571 33.2 51.586 33.365H20.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.526 32.285C12.496 32.48 12.466 32.675 12.466 32.87C12.466 33.035 12.496 33.2 12.511 33.365H0.541016V32.285H12.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.08008 32.825L1.08008 1.32503C1.08008 1.0268 0.838312 0.785034 0.540079 0.785034C0.241845 0.785034 7.77245e-05 1.0268 7.77245e-05 1.32503L7.77245e-05 32.825C7.77245e-05 33.1233 0.241845 33.365 0.540079 33.365C0.838312 33.365 1.08008 33.1233 1.08008 32.825Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.08,
    height: 37.215,
    fill: "white",
    transform: "translate(0 0.785034)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckHome);
export default __webpack_public_path__ + "static/media/truck_home.1e81d7f18f979ed23003447e953d4d95.svg";
export { ForwardRef as ReactComponent };